import { Theme } from '@/styles/theme'
import styled from '@emotion/styled'

const HeaderStyles = (theme: Theme, maxWidth?: string) => `
  max-width: ${maxWidth ?? '612px'};
  width: calc(100% - ${theme.ds.Space4X});
  max-height: 100%;
  padding: 0;
`

export const Content = styled.div<{ hasHeader: boolean; maxWidth?: string }>(
  ({ theme, hasHeader, maxWidth }) => `
    background-color: ${theme.ds.ColorBaseWhite};
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    padding: 20px;
    width: 495px;
    box-shadow: 0px 2px ${theme.ds.Space0X} #00000029;
    border-radius: 8px;
    max-height: 80%;
    overflow: auto;

    ${hasHeader ? HeaderStyles(theme, maxWidth) : ''}

    @media (max-width: 768px) {
      max-height: 100%;
      max-width: 90%;
      padding: ${theme.Space2X};
      box-sizing: border-box;
      position: absolute;
      ${hasHeader ? HeaderStyles(theme, maxWidth) : ''}
    }
  `
)
